import { render, staticRenderFns } from "./printcamer.vue?vue&type=template&id=3879078d&scoped=true&"
import script from "./printcamer.vue?vue&type=script&lang=js&"
export * from "./printcamer.vue?vue&type=script&lang=js&"
import style0 from "./printcamer.vue?vue&type=style&index=0&id=3879078d&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3879078d",
  null
  
)

export default component.exports